import { render } from "./process-update.vue?vue&type=template&id=ffa06b62"
import script from "./process-update.vue?vue&type=script&lang=js"
export * from "./process-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__